<template>
  <div>
    <div class="row profile-dashboard-wrapper border-bottom white-bg dashboard-header">
      <div class="col-lg-5">
        <h2>Automated Email Templates</h2>
      </div>
    </div>

    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row" v-if="loading">
        <div class="col-lg-12">
          <loader message="Loading email templates"/>
        </div>
      </div>

      <div
        class="row"
        v-if="!loading && templates && !templates.length"
      >
        <div class="col-lg-12">
          <div class="empty">No email templates found.</div>
        </div>
      </div>

      <div class="row" v-if="!loading">
        <div class="col-lg-12">
          <template-card
            v-for="template in templates"
            :key="template.id"
            :id="parseInt(template.id, 10)"
            :name="template.name"
            :subject="template.subject"
            :type="template.type"
            :content="template.content"
            @onEdit="handleOnEdit($event, template)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateCard from '@/components/automatedemails/templates/TemplateCard';
import Loader from '@/components/common/Loader';

export default {
  name: 'TemplateList',
  components: {
    TemplateCard,
    Loader,
  },
  props: {
    me: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    templates: {
      type: Array,
      default: () => ([]),
    },
  },
  methods: {
    handleOnEdit(event, template) {
      const path = `/admin/templates/${template.id}`;
      this.$router.push({ path });
    },
  },
};
</script>

<style lang="scss" scoped>
.email-header {
  border-top: 0px;
  padding: 18px;
}
.profile-dashboard-wrapper {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// TemplateList.vue?cb907792